import './polyfills';
import { Manifest } from './configuration/Manifest';
import { loadExternalScripts } from './utils/scripts';
import { EventManager } from './utils/EventManager';
import { TemplateStore } from './stores/TemplateStore';

export const TEMPLATE_STORE = new TemplateStore();

async function initialize() {
    EventManager.init();
    await TEMPLATE_STORE.initialize();
    loadExternalScripts(
        Manifest.externalScripts,
        () => {
            require('./start');
        },
        TEMPLATE_STORE.externalScriptsBasePath || Manifest.getBaseUrl(''),
        TEMPLATE_STORE.cacheOptions
    );
}

initialize();



// WEBPACK FOOTER //
// ./src/index.tsx